// services/membershipPackageService.js
import apiClient from './apiClient';

// Tüm üyelik paketlerini getir
export const getAllMembershipPackages = async () => {
  const response = await apiClient.post('/MembershipPackage/GetAllMembershipPackages');
  return response.data;
};

// ID'ye göre üyelik paketi getir
export const getMembershipPackageById = async (id) => {
  const response = await apiClient.post('/MembershipPackage/GetMembershipPackageById', id);
  return response.data;
};

// Yeni üyelik paketi ekle
export const addMembershipPackage = async (membershipPackageData) => {
  const response = await apiClient.post('/MembershipPackage/AddMembershipPackage', membershipPackageData);
  return response.data;
};

// Üyelik paketi güncelle
export const updateMembershipPackage = async (membershipPackageData) => {
  const response = await apiClient.post('/MembershipPackage/UpdateMembershipPackage', membershipPackageData);
  return response.data;
};

// Üyelik paketi sil
export const deleteMembershipPackage = async (id) => {
  const response = await apiClient.post('/MembershipPackage/DeleteMembershipPackage', null, { params: { id } });
  return response.data;
};